// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2Ni6l","empty":"ModalGraph_empty__3pE-I"};